module.exports = __webpack_public_path__ + "img/car_p.fbe9f359.png";